module.exports = __webpack_public_path__ + "img/phone.0949ebc5.png";